export const BRIGHTCOVE_ACCOUNT_ID = '66036796001';
export const BRIGHTCOVE_PROD_PLAYER_ID = '4JE-ofbdg';
export const BRIGHTCOVE_PROD_PLAYER_ID_CONTENT = '0UgS0urdbr';
export const BRIGHTCOVE_TEST_PLAYER_ID = 'Ntttt09Pyq';